// app/javascript/controllers/ferias/agendadas_controller.js

import { Controller } from "@hotwired/stimulus";
import { initFeriasAgendadasSearch } from "../../modules/ferias/agendadas_search";
import { initFeriasAgendadasActions, initFeriasFiltrosToggle, initHistoricoAutocomplete } from "../../modules/ferias/agendadas_actions";

export default class extends Controller {
  connect() {
    this.search      = initFeriasAgendadasSearch(this.element);
    this.actions     = initFeriasAgendadasActions(this.element);
    this.filtros     = initFeriasFiltrosToggle(this.element);
    this.autocomplete = initHistoricoAutocomplete(this.element);
  }

  disconnect() {
    this.search?.destroy?.();
    this.actions?.destroy?.();
    this.filtros?.destroy?.();
    this.autocomplete?.destroy?.();
  }
}
